import { getWeek } from '../../../utils/dateTime';
import { trackEvent } from '../../../utils/tracking';

export const selectPeriod = (periods, period) => {
  if (period && period.out && period.home) {
    if (findSelectedPeriod(periods, period)) {
      return findSelectedPeriod(periods, period);
    } else return periods[0];
  } else {
    return periods[0];
  }
};

export const findSelectedPeriod = (periods, period) => {
  return periods.find((dp) => {
    const dpOut = new Date(dp.out);
    const dpHome = new Date(dp.home);

    const periodOut = new Date(period.out);
    const periodHome = new Date(period.home);

    return (
      dpOut.toDateString() === periodOut.toDateString() &&
      dpHome.toDateString() === periodHome.toDateString()
    );
  });
};

export const getUrlParameter = (name) => {
  if (window === undefined) return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

export const trackFeedItem = (item, index) => {
  const period = {
    out: item.flightCharter?.out || item.hotel?.checkinDate,
    home: item.flightCharter?.home || item.hotel?.checkoutDate,
  };

  return {
    index: index,
    item_name: item.destination.description,
    item_id: item.hotel?.info.name,
    item_category: item.package.description,
    item_brand: '', //season
    price: item.price,
    discount: item.ordinaryPrice - item.price,
    quantity: 1,
    pax: item.travelerIds.length,
    pax_adults: 0,
    pax_children: 0,
    destination: item.destination.description,
    week: getWeek(period.home),
  };
};
export const trackFeedItems = (items, search) => {
  let trackitems = [];

  items.forEach((item, index) => trackitems.push(trackFeedItem(item, index)));

  trackEvent(
    'view_item_list',
    {
      ecommerce: {
        item_list_id: 'feed',
        item_list_name: `Feed ${search.airport} > ${
          search.destination === '*' ? 'All' : search.destination
        }`, //airport + destination
        items: trackitems,
      },
    },
    true,
  );
};

export const trackError = (error, url) => {
  trackEvent('error', {
    error_message: `${error.code} - ${error.message}`,
    error_url: url,
  });
};

export const trackFeedItemSelect = (item) => {
  const trackObject = {
    ecommerce: {
      value: item.price,
      items: [
        {
          item_name: item.destination.description,
          item_id: item.hotel?.info.name,
          item_category: item.package.description,
          item_brand: '', //season
          price: item.price,
          discount: item.ordinaryPrice - item.price,
          quantity: 1,
          pax: item.travelerIds.length,
          pax_adults: 0,
          pax_children: 0,
          destination: item.destination.description,
          week: getWeek(item.period.home),
        },
      ],
    },
  };

  trackEvent('view_item', trackObject);
};
